import { render, staticRenderFns } from "./student-drawer.vue?vue&type=template&id=6033716d&"
import script from "./student-drawer.vue?vue&type=script&lang=js&"
export * from "./student-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports